import projectOne from "../images/Capture.PNG"
import projectTwo from "../images/flower.jpg"
import projectThree from "../images/work.jpg"

const projects = [
    {
        id: "01",
        name: "Weather app",
        imgSrc: projectOne,
        about: "This is the weather application where you enter the name of city or country to see its weather details",
        url: "https://weatherdetail.netlify.app/"
    },
    {
        id: "02",
        name: "Project Two",
        imgSrc: projectTwo,
        about: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. At ultrices eget turpis scelerisque eu libero euismod fringilla integer. Viverra sit vestibulum morbi mattis malesuada.",
        url: "#"
    },
    {
        id: "03",
        name: "Project Three",
        imgSrc: projectThree,
        about: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. At ultrices eget turpis scelerisque eu libero euismod fringilla integer. Viverra sit vestibulum morbi mattis malesuada.",
        url: "#"
    },
    {
        id: "04",
        name: "Project Four",
        imgSrc: projectTwo,
        about: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. At ultrices eget turpis scelerisque eu libero euismod fringilla integer. Viverra sit vestibulum morbi mattis malesuada.",
        url: "#"
    },
    {
        id: "05",
        name: "Project Five",
        imgSrc: projectThree,
        about: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. At ultrices eget turpis scelerisque eu libero euismod fringilla integer. Viverra sit vestibulum morbi mattis malesuada.",
        url: "#"
    }
]

export default projects